/**
 * Surfaces the Jenkins-injected `BUILD_VERSION` at runtime so QA / on-call
 * can confirm which build is live without rebuilding. Vite replaces
 * `__BUILD_VERSION__` at build time with the value of `process.env.BUILD_VERSION`
 * (e.g. `hml-123`, `prd-456`) or `'local'` outside CI.
 *
 * Inspired by the same convention used in @webmotors/vender:
 *   - `<meta name="build-version" content="hml-123">` in <head>
 *   - `console.info("🏷️ Build Version: hml-123")` on boot
 */
const META_NAME = 'build-version';
const LOG_PREFIX = '🏷️ Build Version:';

const injectBuildVersionMeta = (version: string): void => {
	if (typeof document === 'undefined') return;

	const existing = document.querySelector<HTMLMetaElement>(`meta[name="${META_NAME}"]`);
	if (existing) {
		existing.setAttribute('content', version);
		return;
	}

	const meta = document.createElement('meta');
	meta.setAttribute('name', META_NAME);
	meta.setAttribute('content', version);
	document.head.appendChild(meta);
};

const getBuildVersion = (): string => __BUILD_VERSION__;

const exposeBuildVersion = (): string => {
	const version = getBuildVersion();
	injectBuildVersionMeta(version);
	console.info(`${LOG_PREFIX} ${version}`);
	return version;
};

export { exposeBuildVersion, getBuildVersion };
